import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const NEW_TOOLS = [
  {
    id: "studio-character",
    label: "Crear Personaje Base",
    description: "Genera cara y cuerpo del personaje con vistas múltiples",
    path: "/studio/character",
    active: true,
    group: "Crear Assets",
  },
  {
    id: "studio-details",
    label: "Crear Detalles",
    description: "Ropa, complementos y artefactos reutilizables",
    path: "/studio/details",
    active: true,
    group: "Crear Assets",
  },
  {
    id: "studio-character-sheet",
    label: "Crear Hoja Personaje",
    description: "Variaciones vestidas del personaje para cada toma",
    path: "/studio/character-sheet",
    active: true,
    group: "Crear Assets",
  },
  {
    id: "studio-scene",
    label: "Crear Escenario",
    description: "Entornos y locaciones reutilizables",
    path: "/studio/scene",
    active: true,
    group: "Crear Assets",
  },
  {
    id: "studio-shot",
    label: "Crear Imagen de Toma",
    description: "Compone escenario + personajes + artefactos en una imagen",
    path: "/studio/shot",
    active: true,
    group: "Producción",
  },
  {
    id: "studio-video",
    label: "Crear Vídeo-Toma",
    description: "Genera vídeo desde imagen de toma con refs de refuerzo",
    path: "/studio/video",
    active: true,
    group: "Producción",
  },
];

export default function NewToolsMenu() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const activeTool = NEW_TOOLS.find((t) => location.pathname.startsWith(t.path));

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const select = (item) => {
    if (!item.active) return;
    setOpen(false);
    navigate(item.path);
  };

  const renderItems = () => {
    const items = [];
    let lastGroup = null;
    for (const tool of NEW_TOOLS) {
      if (tool.group && tool.group !== lastGroup) {
        items.push(
          <div key={`group-${tool.group}`} className="tools-menu-group">
            {tool.group}
          </div>
        );
        lastGroup = tool.group;
      }
      items.push(
        <div
          key={tool.id}
          className={`tools-menu-item tools-menu-item--indented ${activeTool?.id === tool.id ? "active" : ""} ${!tool.active ? "disabled" : ""}`}
          onClick={() => select(tool)}
        >
          <div className="tools-menu-item-label">
            {tool.label}
            {!tool.active && <span className="tools-soon-badge">pronto</span>}
          </div>
          <div className="tools-menu-item-desc">{tool.description}</div>
        </div>
      );
    }
    return items;
  };

  return (
    <div className="tools-menu" ref={ref}>
      <button
        className={`tools-menu-trigger ${open ? "open" : ""}`}
        onClick={() => setOpen(!open)}
      >
        <span className="tools-menu-label" style={{ color: "#a29bfe" }}>Studio</span>
        {activeTool && <span className="tools-menu-current">{activeTool.label}</span>}
        <span className="tools-menu-chevron">{open ? "\u25B4" : "\u25BE"}</span>
      </button>

      {open && (
        <div className="tools-menu-dropdown">
          {renderItems()}
        </div>
      )}
    </div>
  );
}
